var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "square-with-icon" }, [
    _c("span", { staticClass: "icon" }, [
      _c("i", { class: _vm.iconClass, attrs: { "aria-hidden": "true" } }),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }